import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Pagination from "react-js-pagination";
import toast from "react-hot-toast";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import { getAllStudentList } from "services/student/studentController";
import { Input } from "components/Form";
import { Button } from "components/Button/Button";

export default function StudentList() {
    const [record, setRecord] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [search, setSearch] = useState("");
    const [total, setTotal] = useState(0);
    const [limit, setLimit] = useState(10);

    const [loader, showLoader, hideLoader] = useFullPageLoader();

    const handleRecords = async (page = activePage) => {
        try {
            showLoader();

            const res = await getAllStudentList({
                page: page,
                search: search,
                limit: limit,
            });

            hideLoader();

            if (res.code === 200) {
                const rows = res.data.allstudent.rows || [];
                const count = res.data.allstudent.count || 0;

                setRecord(rows);
                setTotal(count);
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            hideLoader();
            toast.error(err?.response?.data?.message || err.message);
        }
    };

    useEffect(() => {
        handleRecords();
    }, [activePage, limit, search]);


    const resetFilter = () => {
        setSearch("");
    };
    return (
        <>
            <div className="WrapperBox">
                <div className="Small-Wrapper">
                    <div className="search_wrap">
                        <form
                            style={{
                                width: "60%",
                                display: "flex",
                                justifyContent: "flex-end",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <input
                                type="text"
                                placeholder="Search"
                                className="form-control"
                                style={{ width: "300px" }}
                                value={search}
                                onChange={(e) => {
                                    setActivePage(1);
                                    setSearch(e.target.value);
                                }}
                            />

                            <div>
                                <Button className="refresh_btnn mx-2" onClick={resetFilter}>
                                    <i className="fa fa-refresh"></i>
                                </Button>
                            </div>
                        </form>

                        <h4 className="Title">All Students List</h4>
                    </div>

                    <div className="TableList overflow-auto table-responsive">
                        {loader}
                        <Table bordered className="table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Email</th>
                                    <th>Mobile</th>
                                </tr>
                            </thead>
                            <tbody>
                                {record && record.length > 0 ? (
                                    record.map((student, index) => (
                                        <tr key={student.UserID}>
                                            <td>{index + 1 + (activePage - 1) * limit}</td>
                                            <td>{student.FirstName}</td>
                                            <td>{student.LastName}</td>
                                            <td>{student.EmailID}</td>
                                            <td>{student.Mobile}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <NotFound cols={5} />
                                )}
                            </tbody>
                        </Table>
                    </div>

                    {total > limit ? (
                        <div className="Pagination">
                            <Pagination
                                activePage={activePage}
                                previousLabel={"previous"}
                                nextLabel={"next"}
                                itemsCountPerPage={limit}
                                totalItemsCount={total}
                                pageRangeDisplayed={5}
                                onChange={(page) => setActivePage(page)}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        </>
    );
}
